/**
 * 检测是否有doc click
 */
import { useEffect } from 'react';
import { $document } from '@umu/umu-dom';

export interface IOptions {
    excludeSelector?: string;
}

export function useDocClick(listener: () => void, options: IOptions) {
    const excludeDoc = (ev: MouseEvent) => {
        if (!options.excludeSelector || !ev || !ev.target) {
            return;
        }
        const excludeEl = $document.querySelector(options.excludeSelector);
        if (!excludeEl) {
            return;
        }
        const target = ev.target as Node;
        const isContains = excludeEl.contains(target);
        if (isContains) {
            return;
        }
        listener();
    };

    const handler = (ev: MouseEvent) => {
        excludeDoc(ev);
        // if (!!listener) {
        //     listener();
        // }
    };

    useEffect(() => {
        $document.addEventListener('click', handler);
        return () => {
            $document.removeEventListener('click', handler);
        };
    }, []);
}
